import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=58d2ae52&scoped=true&"
import script from "./ControlBar.vue?vue&type=script&lang=js&"
export * from "./ControlBar.vue?vue&type=script&lang=js&"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=58d2ae52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2ae52",
  null
  
)

component.options.__file = "www/vues/client/controls/ControlBar.vue"
export default component.exports